import React from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import "react-responsive-modal/styles.css";
import { Modal as ReactModal } from "react-responsive-modal";
import Spinner from "../Spinner";

const ModalLoading = ({
  title = "",
  children = undefined,
  onClose = () => {},
  isOpen,
  ...rest
}) => {
  return (
    <>
      <GlobalStyles />
      <ReactModal
        center
        closeOnOverlayClick={false}
        open={isOpen}
        showCloseIcon={false}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
        {...rest}
      >
        <ModalContainer>
          <Spinner />
        </ModalContainer>
      </ReactModal>
    </>
  );
};

const ModalContainer = styled.div``;

const GlobalStyles = createGlobalStyle`
  @media (min-width: 501px) {
    .customModal {
      border-radius: 15px;
      border: 1px solid #ccc;
      padding: 25px;
      /* overflow-y: visible; */
    }

    ${ModalContainer} {
      /* max-width: 500px; */
      /* width: 80vw; */
    }
  }

  /* @media (max-width: 500px) {
    .customModal {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      margin: 0;
    }

    ${ModalContainer} {
      width: 100%;
    }
  } */
`;

export default ModalLoading;
